var render = function render(){var _vm=this,_c=_vm._self._c;return _c('step',{key:_vm.key,attrs:{"data":_vm.currentStep},on:{"success":_vm.nextStep,"ended":function($event){return _vm.$emit('ended')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }